import React from "react"
import styled, { css } from "styled-components"

import { Container } from "../components/Grid"
import { media } from "../styles/globalTheme"

export const ScreenReaderText = styled.span`
  display: block;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(1px);
  white-space: nowrap;
  position: absolute;
`

export const ScreenReaderElement = styled.span`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`

const skipLinkPosition = css`
  left: 18px;
  position: fixed;
  top: var(--header-height);
  z-index: 1000;
`

const SkipLinkListContainer = styled.ul`
  ${skipLinkPosition}
  list-style: none;
  margin: 0;
  padding: 0;

  @media ${media.sm} {
    left: 0;
    position: relative;
    top: 0;
  }

  li {
    margin: 0;
    padding: 0;
  }
`

export const SkipLinkLocalContainer = styled.div`
  ${skipLinkPosition}
  width: 100%;
  left: 0;

  @media ${media.md} {
    top: calc(var(--header-height) + 10px);
  }

  @media ${media.lg} {
    top: calc(var(--header-height-lg) + 20px);
  }
`

export const SkipLink = styled.a`
  background-color: var(--color-white);
  color: var(--color-spaceblue);
  font-size: var(--font-size-13);
  font-weight: 700;
  left: -1000px;
  outline-offset: 1px !important;
  padding: 8px;
  position: absolute;
  text-decoration: underline;
  top: -1000px;
  z-index: 1;

  @media ${media.md} {
    font-size: var(--font-size-15);
    padding: 6px 8px;
  }

  &:focus {
    left: 0;
    position: relative;
    top: 0;
  }
`

export const SkipLinkLocal = ({ children }) => {
  return (
    <SkipLinkLocalContainer>
      <Container>{children}</Container>
    </SkipLinkLocalContainer>
  )
}

export const SkipLinksGlobal = ({ children }) => {
  return (
    <SkipLinkListContainer>
      {children.map((child, index) => (
        <li key={index}>{child}</li>
      ))}
    </SkipLinkListContainer>
  )
}
